import { render, staticRenderFns } from "./BaseInputSwitch.vue?vue&type=template&id=21b61428&scoped=true&"
import script from "./BaseInputSwitch.vue?vue&type=script&lang=js&"
export * from "./BaseInputSwitch.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputSwitch.vue?vue&type=style&index=0&id=21b61428&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b61428",
  null
  
)

export default component.exports